import * as types from '../types'

const initialState = {
    loading: false,
    accounts: [],
    account: {},
    error: null
}

export const accountReducer = (state = initialState, action) => {
    switch (action.type) {

        case types.GET_MY_ACCOUNTS:
            return {
                ...state, 
                accounts: action.payload,
                loading: false,
                error: null
            }

        case types.SET_LOADING:
            return {
                ...state,
                loading: true,
                error:null
            }
        case types.RESET_LOADING:
            return {
                ...state,
                loading: true,
                error:null
            }
        case types.RESET:
            return {
                ...state,
                loading: false,
                error:null
            }
        case types.CLEAR:
            return {
                ...state,
                accounts: null,
                loading: false,
                error:null
            }
        case types.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        default:
            return state
    }
}